import React, { useState, useEffect } from "react";
import './App.css';

const App = () => {
    const [data, setData] = useState([]);             // alle Daten
    const [filteredData, setFilteredData] = useState([]); // nur die letzten X Tage
    const [serverUrl, setServerUrl] = useState(null);
    const [error, setError] = useState(null);
    const [showText, setShowText] = useState(true);
    const [lastDays, setLastDays] = useState(14);
    const [showAll, setShowAll] = useState(false);

    // 1. Config einlesen
    useEffect(() => {
        try {
            const config = window.APP_CONFIG;
            if (!config || !config.SERVER_URL) {
                throw new Error("Keine gültige Konfiguration gefunden.");
            }

            setServerUrl(config.SERVER_URL);

            const days = parseInt(config.LAST_DAYS_VISIBLE);
            setLastDays(!isNaN(days) ? days : 14);

            setShowText(config.SHOW_TEXT === true || config.SHOW_TEXT === "true");
        } catch (err) {
            setError("Konnte die Konfiguration nicht laden: " + err.message);
        }
    }, []);

    // 2. Daten abrufen und nach Datum filtern
    useEffect(() => {
        if (!serverUrl || lastDays <= 0) return;

        const fetchData = async () => {
            try {
                const response = await fetch(`${serverUrl}/wp-json/cl-vehicle-handover/v1/data`);
                if (!response.ok) {
                    throw new Error("Fehler beim Abrufen der Daten");
                }
                const result = await response.json();

                const today = new Date();

                const filtered = result.filter(item => {
                    if (!item.date) return false;
                    const [day, month, year] = item.date.split(".");
                    const itemDate = new Date(`${year}-${month}-${day}`);
                    const diffDays = (today - itemDate) / (1000 * 60 * 60 * 24);
                    return diffDays <= lastDays;
                });

                setData(result);
                setFilteredData(filtered);
            } catch (err) {
                setError("Fehler beim Laden der Daten: " + err.message);
            }
        };

        fetchData();
    }, [serverUrl, lastDays]);

    if (error) return <div>Fehler: {error}</div>;
    if (!serverUrl) return <div>Lade Konfiguration...</div>;
    if (data.length === 0) return <div>Lade Daten...</div>;

    const visibleItems = showAll ? data : filteredData;

    return (
        <div className="container-fluid mt-4">
            <div className="row">
                {visibleItems.map((item, index) => (
                    <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-3 mb-3">
                        <div className="card h-100 text-black shadow-sm">
                            <div className="card-body carlead">
                                <img src={item.image} alt={item.title} className="img-fluid mb-2" />
                                <div className="p-2">
                                    <h3>{item.title}</h3>
                                    {showText && <p>{item.description}</p>}
                                    
                                    <p class="font-customer" dangerouslySetInnerHTML={{ __html: item.userdata }}></p>
                                    
                                    <small>{item.date}</small>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {!showAll && data.length > filteredData.length && (
                <div className="text-center mt-4">
                    <button className="btn btn-carlead" onClick={() => setShowAll(true)}>
                        Mehr anzeigen
                    </button>
                </div>
            )}
        </div>
    );
};

export default App;
